import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../contexts/LanguageContext'; // Import the LanguageContext

const Menu = () => {
    const { language, t, handleLanguageChange } = useContext(LanguageContext); // Access global language state

    return (
        <ul className="menu">
            <li><Link to="/">{t.home}</Link></li>
            <li><Link to="/about-us">{t.about_us}</Link></li>
            <li><Link to="/service">{t.service}</Link></li>
            <li><Link to="/our-csr">{t.our_csr}</Link></li>
            <li><Link to="/careers">{t.careers}</Link></li>
            <li><Link to="/highlights-insights">{t.highlights_insights}</Link></li>
            <li><Link to="/contact-us">{t.contact_us}</Link></li>
            <li className="dropdown">
                <span>{language}</span>
                <ul className="dropdown-menu">
                    <li><button onClick={() => handleLanguageChange('EN')}>EN</button></li>
                    <li><button onClick={() => handleLanguageChange('FR')}>FR</button></li>
                </ul>
            </li>
        </ul>
    );
};

export default Menu;